import React from "react"
import RecordTable from "./RecordTable"
import RecordTableActionBar from "./RecordTableActionBar"
import { CircularProgress, Toggle } from "material-ui"
import { IRecord, ERecordSearchFilter, ERecordPageType, IDateRange } from "../../models"
import strings from "../../localization/strings"

interface IProps {
  loading: boolean
  pageMode: ERecordPageType
  selectedFilter: ERecordSearchFilter
  total?: number
  offset?: number
  limit?: number
  limitOptions?: number[]
  records: IRecord[]
  onPageClick?(offset: number): void
  onLimitChange?(limit: number): void
  handleChangeSelectedFilter?(selectedFilter: ERecordSearchFilter): void
  reload(initOffset: boolean): void

  dateRange?: IDateRange
  handleChangeDateRange?(dateRange: IDateRange): void

  handleDownload?(): void
}
interface IState {
  showThumbnail: boolean
}

export default class Records extends React.Component<IProps, IState>  {
  constructor(props: IProps) {
    super(props)
    this.state = {
      showThumbnail: false
    }
  }

  render() {
    return (
      <div>
        <RecordTableActionBar
          loading={this.props.loading}
          showThumbnail={this.state.showThumbnail}
          selectedFilter={this.props.selectedFilter}
          dateRange={this.props.dateRange}
          handleChangeShowThumbnail={showThumbnail => this.setState({ showThumbnail })}
          handleChangeSelectedFilter={this.props.handleChangeSelectedFilter}
          handleChangeDateRange={this.props.handleChangeDateRange}
          reload={() => this.props.reload(false)}
          handleDownload={this.props.handleDownload}
        />
        <div style={{ padding: 20 }}>
          {this.props.loading ?
            <div className="spinner" style={{ paddingBottom: "2em" }}>
              <CircularProgress />
            </div> :
            this.props.total > 0 ?
              <RecordTable
                pageMode={this.props.pageMode}
                selectedFilter={this.props.selectedFilter}
                records={this.props.records}
                offset={this.props.offset}
                limit={this.props.limit}
                limitOptions={this.props.limitOptions}
                total={this.props.total}
                showThumbnail={this.state.showThumbnail}
                onPageClick={this.props.onPageClick}
                onLimitChange={this.props.onLimitChange}
                reload={this.props.reload}
              /> :
              <h2 style={{ textAlign: "center", marginTop: "25px", marginBottom: "25px" }}>
                {strings.No_Records}
              </h2>
          }
        </div>
      </div>
    )
  }
}
